/* Desktop index rail — numbered sections with a scroll-progress line and
   the active-section highlight. Hidden on mobile (see site.css). The list
   comes from the editable section registry (passed from PublicSite). */
export function IndexRail({ active, progress, goTo, sections }) {
  return (
    <nav className="rail" aria-label="Section index">
      <div className="rail-mark wordmark">
        Curated<b>H</b>omes
      </div>
      <div className="rail-track">
        <div className="rail-progress">
          <i style={{ height: progress * 100 + '%' }}></i>
        </div>
        <ul>
          {sections.map((s) => (
            <li key={s.key}>
              <button className={active === s.key ? 'active' : ''} onClick={() => goTo(s.key)}>
                <span className="rn">{s.num}</span>
                <span className="rt">{s.label.toUpperCase()}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  )
}
